/* this file added by Bearer Web Developer  */
import React from 'react';
import { Snackbar } from '@mui/material';
import styles from './toastMui.module.scss';

interface Props {
    handleClose: () => void
    open: boolean
}

const ToastMui: React.FC<Props> = ({ handleClose, open }) => {

    const handleCloseFunction = (
        event?: React.SyntheticEvent | Event,
        reason?: string
    ) => {
        if (reason === 'clickaway') return;
        handleClose();
    };

    return (
        <>
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleCloseFunction}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <div className={styles.toast_mui}>
                    <img src="/rate-review.svg" alt="" width={24} height={24} />
                    <p>Rate or wait for pending orders before starting a new one.</p>
                    <figure className={styles.close}>
                        <img src="/close-gray.svg" alt="" width={16} height={16} onClick={handleCloseFunction} />
                    </figure>
                </div>
            </Snackbar>
        </>
    );
};

export default ToastMui;
